import Image from 'next/image';
import Link from 'next/link';
import logoColored from '../../../public/logoColored.svg';

function Logo({ size, className }: { size?: number; className?: string }) {
  return (
    <Link href="/" className="flex items-center">
      <Image
        src={logoColored}
        width={size}
        height={size}
        quality={100}
        className={className}
        alt="Eram Media Logo"
      />
    </Link>
  );
}

export default Logo;
